import { useState, useContext, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import './AddProductsAsAlternateToListForm.scss';

import { callGTMAnalytics } from '../../helper/analyticsTag';
import { useRecoilState } from 'recoil';
import utagObjectAtom from '../../recoils/useUtagObject/utagObjectAtom';
import { SpinnerForm } from '../../components/spinner';
import { AuthContext } from '../../context/UserContext';
import { getLangSite } from "../../ultils/translation.util";
import { addProductsAlternateToList, getListNameById } from '../../services';

interface ModalProps {
  isFormOpen: boolean;
  setIsFormOpen: (isFormOpen: boolean) => void;
  selectedData: any;
  isReverse: boolean;
  listId: string;
  uniqueId: string;
  searchQuery: string;
  pinnedRowData: any;
}

const AddProductsAsAlternateToListForm: React.FC<ModalProps> = ({
  isFormOpen,
  setIsFormOpen,
  selectedData,
  isReverse,
  listId,
  uniqueId,
  searchQuery,
  pinnedRowData
}) => {
  const { t } = useTranslation();

  const [linkToList, setLinkToList] = useState<string>('');
  const [listDetail, setListDetail] = useState<any>({});
  const { userData } = useContext(AuthContext);
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [utagData] = useRecoilState(utagObjectAtom);

  useEffect(() => {
    const getListObject = async () => {
      // Define newArray as an empty array
      const bodyRequest: string[] = [];

      // ! PARAM TO CALL API
      selectedData.forEach((element: any) => {
        bodyRequest.push(
          element.manufacturerProductNumber
        );
      });
      // push source part's manufacturerProductNumber to bodyRequest to add to alternate
      if(pinnedRowData){
        bodyRequest.push(pinnedRowData.data.manufacturerProductNumber);
      }
      // ! ACTION CALL API ADD PART TO LIST
      setIsFetching(true);
      const resultAddPartsToList = await addProductsAlternateToList(
        userData.CustomerId,
        listId,
        uniqueId,
        bodyRequest
      );

      const responseObject = await getListNameById(userData.CustomerId, listId);
      setListDetail(responseObject);

      setIsFetching(false);
      if (resultAddPartsToList === "OK") {
        setIsSuccess(true);

        // ! Get lang from URL
        const langSiteObj = getLangSite('en');
        const lang = langSiteObj.lang;
        setLinkToList(`${window.location.origin}/${lang}/mylists/list/${listId}`);
      } else {
        setIsSuccess(false);
      }
    };
    // Get new list when the add alternate form is open
    if (isFormOpen) {
      getListObject();
    }
  }, [isFormOpen, listId]);


  const onClose = () => {
    setIsFormOpen(!isFormOpen);
  };

  return isFormOpen ? (
    <div className="add-to-list-modal">
      <div className="dialog-add-to-list-modal">
        <div className="modal-box">
          <div className="modal-header-form-custom">
            <div className="modal-title-area">
              <h3 className="modal-title-form-custom">
                {' '}
                {t('xref-add-alternate')}{' '}
              </h3>
            </div>
            <button
              type="button"
              className={
                'close-button-form-area ' +
                (isReverse ? 'left-0' : 'right-0')
              }
              data-dismiss="modal"
              onClick={onClose}
            >
              ×
            </button>
          </div>
          {isFetching ? (
            <SpinnerForm />
          ) : isSuccess ? (
            <div>
              <div>
                <h4 className="fw-bold my-1">{(selectedData.length > 1 || (pinnedRowData && selectedData.length > 0)) ? t('xref-these-products-have-been-added-as-alternates-to-your-list') : t('xref-this-product-has-been-added-as-alternate-to-your-list')} </h4>
                <h4 className="fw-bold pb-0"> {t('xref-tbl-hd-mrf-part')} </h4>
                {
                  pinnedRowData && (
                    <div>
                      <span className="mt-1">{pinnedRowData.data.manufacturerProductNumber}</span>
                    </div>
                  )
                }
                {selectedData && selectedData.length > 0 &&
                  selectedData.map((sData: any) => (
                    <div key={sData.masterPartId}>
                      <span className="mt-1">{sData.manufacturerProductNumber}</span>
                    </div>
                  ))}

                <div className="mt-2 mb-4">
                  <h4 className="fw-bold pb-0">{t('xref-list-name')}</h4>
                  <div>
                    {listDetail?.listName}
                  </div>
                </div>
              </div>
              <div className="action-button-container">
                <div className="add-to-list-btn-area ">
                  <a
                    href={linkToList}
                    rel="noreferrer"
                    className="dk-btn__primary view-list-link"
                  >
                    {t('xref-view-list')}
                  </a>
                </div>
                <div className="close-btn-area justify-content-end">
                  <button
                    type="button"
                    className="dk-btn__secondary"
                    data-dismiss="modal"
                    data-testid="close-test-success-btn"
                    onClick={onClose}
                  >
                    {t('xref-close')}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div className="mb-2">
                <p>{t('xref-an-error-message')}{' '}{t('xref-if-the-issue-persists')}</p>
                <a
                  href={`https://feedback.digikey.com/jfe/form/SV_ekZ6xvJDGrPXQhM${searchQuery.trim()
                    ? '?MfrPartNumber=' + encodeURIComponent(searchQuery)
                    : ''
                    }`}
                  className="dk-link"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => callGTMAnalytics(utagData, "Feedback and Suggestions")}
                  track-data="ref_page_event=Feedback and Suggestions"
                >
                  {t('xref-please-let-us-know')}
                </a>
              </div>

              <div className="action-button-container">
                <div className="add-to-list-btn-area ">
                  <button
                    type="submit"
                    className="dk-btn__primary"
                    data-dismiss="modal"
                    onClick={onClose}
                    data-testid="close-test-failed-btn"
                  >
                    {t('xref-ok')}
                  </button>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  ) : null;
};

export default AddProductsAsAlternateToListForm;
